__turbopack_context__.v({
  "align-center": "_1mDwSW_align-center",
  "align-end": "_1mDwSW_align-end",
  "align-start": "_1mDwSW_align-start",
  "gap-lg": "_1mDwSW_gap-lg",
  "gap-md": "_1mDwSW_gap-md",
  "gap-sm": "_1mDwSW_gap-sm",
  "gap-xl": "_1mDwSW_gap-xl",
  "gap-xs": "_1mDwSW_gap-xs",
  "gap-xxl": "_1mDwSW_gap-xxl",
  "justify-around": "_1mDwSW_justify-around",
  "justify-between": "_1mDwSW_justify-between",
  "justify-center": "_1mDwSW_justify-center",
  "justify-end": "_1mDwSW_justify-end",
  "justify-start": "_1mDwSW_justify-start",
  "mb-lg": "_1mDwSW_mb-lg",
  "mb-md": "_1mDwSW_mb-md",
  "mb-sm": "_1mDwSW_mb-sm",
  "mb-xl": "_1mDwSW_mb-xl",
  "mb-xs": "_1mDwSW_mb-xs",
  "mb-xxl": "_1mDwSW_mb-xxl",
  "ml-lg": "_1mDwSW_ml-lg",
  "ml-md": "_1mDwSW_ml-md",
  "ml-sm": "_1mDwSW_ml-sm",
  "ml-xl": "_1mDwSW_ml-xl",
  "ml-xs": "_1mDwSW_ml-xs",
  "ml-xxl": "_1mDwSW_ml-xxl",
  "mr-lg": "_1mDwSW_mr-lg",
  "mr-md": "_1mDwSW_mr-md",
  "mr-sm": "_1mDwSW_mr-sm",
  "mr-xl": "_1mDwSW_mr-xl",
  "mr-xs": "_1mDwSW_mr-xs",
  "mr-xxl": "_1mDwSW_mr-xxl",
  "mt-lg": "_1mDwSW_mt-lg",
  "mt-md": "_1mDwSW_mt-md",
  "mt-sm": "_1mDwSW_mt-sm",
  "mt-xl": "_1mDwSW_mt-xl",
  "mt-xs": "_1mDwSW_mt-xs",
  "mt-xxl": "_1mDwSW_mt-xxl",
  "mx-lg": "_1mDwSW_mx-lg",
  "mx-md": "_1mDwSW_mx-md",
  "mx-sm": "_1mDwSW_mx-sm",
  "mx-xl": "_1mDwSW_mx-xl",
  "mx-xs": "_1mDwSW_mx-xs",
  "mx-xxl": "_1mDwSW_mx-xxl",
  "my-lg": "_1mDwSW_my-lg",
  "my-md": "_1mDwSW_my-md",
  "my-sm": "_1mDwSW_my-sm",
  "my-xl": "_1mDwSW_my-xl",
  "my-xs": "_1mDwSW_my-xs",
  "my-xxl": "_1mDwSW_my-xxl",
  "shimmer": "_1mDwSW_shimmer",
  "stack": "_1mDwSW_stack",
  "text-bar-sweep": "_1mDwSW_text-bar-sweep",
});
